import { createFileRoute } from "@tanstack/react-router";
import { PartnerShell } from "../../../features/partner/components/partner-shell";
import { PartnerTripsPage } from "../../../features/partner/pages/partner-trips-page";

/** `/{lang}/partner`: "Your trips". */
export const Route = createFileRoute("/$lang/_partner/partner/")({
  component: PartnerTripsRoute,
});

function PartnerTripsRoute() {
  const { lang } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PartnerShell lang={lang} search={search} tab="trips">
      <PartnerTripsPage search={search} />
    </PartnerShell>
  );
}
